import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_36.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter36.json";


function Chapter_36() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
      <Head>
        <title>GRAVITY AND CONSCIOUSNESS | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXXVII"
        ></meta>
        <meta
          property="og:title"
          content="GRAVITY AND CONSCIOUSNESS | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="An abstract visualization of gravity interacting with waves of consciousness, depicting the profound connection between physical forces and mental states. The image shows cosmic elements intertwined with neural patterns, symbolizing how gravity and consciousness influence each other in the framework of divine understanding."></meta>
        <meta
          property="og:description"
          content="Explore the Central Doctrine on Gravity and Consciousness, where the fundamental forces of the universe intersect with the nature of the mind. Delve into how gravity influences consciousness and vice versa, revealing a profound connection between physical laws and mental states in the framework of divine understanding."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=36"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="An abstract visualization of gravity interacting with waves of consciousness, depicting the profound connection between physical forces and mental states. The image shows cosmic elements intertwined with neural patterns, symbolizing how gravity and consciousness influence each other in the framework of divine understanding."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=36"></meta>
        <meta name="twitter:title" content="GRAVITY AND CONSCIOUSNESS | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the Central Doctrine on Gravity and Consciousness, where the fundamental forces of the universe intersect with the nature of the mind. Delve into how gravity influences consciousness and vice versa, revealing a profound connection between physical laws and mental states in the framework of divine understanding."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=36" />
      </Head>


      <Common_html BlockData={BlockData} />

    </>
  );
}

export default Chapter_36;
